export const setItem = async (key: string, value: any) => {
  try {
    await null;
    return localStorage.setItem(key, value);
  } catch (e) {
    console.error(e);
  }
};

export const getItem = async (key: string) => {
  try {
    await null;
    return localStorage.getItem(key);
  } catch (e) {
    console.error(e);
  }
};

export const getToken = () => {
  let accessToken = null;
  let isToken = localStorage.getItem('trinkerr.token' || '');
  if (isToken !== null) {
    let tokenData = JSON.parse(isToken);
    if (tokenData !== null && tokenData.accessToken !== undefined) {
      accessToken = tokenData.accessToken;
    }
  }

  return accessToken;
};
